export const ADD_PERSONAL_INFO = "ADD_PERSONAL_INFO";
export const ADD_ALL_PERSONAL_INFO = "ADD_ALL_PERSONAL_INFO";
export const ADD_FIELD_COUNT = "ADD_FIELD_COUNT";
export const SET_MODIFIED = "SET_MODIFIED";
export const RESET_STATE = "RESET_STATE";
export const SET_EMPTY = "SET_EMPTY";






export const addPersonalInfo = (data) => {
  return {
    type: ADD_PERSONAL_INFO,
    data,
  };
};
export const resetState = (data) => {
  return {
    type: RESET_STATE,
  };
};

export const setEmpty = (data) => {
  console.log('in empty')
  return {
    type: SET_EMPTY,
    data
  };
};

export const isModified = (data) => {
  return {
    type: SET_MODIFIED,
    data,
  };
};

export const addFieldCount = (data) => {
  return {
    type: ADD_FIELD_COUNT,
    data,
  };
};



export const addAllPersonalInfo = (data) => {
  return {
    type: ADD_ALL_PERSONAL_INFO,
    data,
  };
};


